import { useNavigate } from 'react-router';
import FitButtons from '../Components/FitButton';

export const AdsCard = (props) => {
  const navigate = useNavigate();

  const handleShowForm = (to) => {
    navigate(to);
  };

  return (
    <div className=' flex flex-col items-start lg:flex-row gap-2 lg:gap-4 py-6 px-4 shadow-md rounded-md'>
      <img src={props?.image} alt='subscription' className='max-h-[64px]' />
      <div className='flex gap-4 flex-col'>
        <h3 className='font-semibold'>{props.title}</h3>
        <p className=''>{props.paragraph}</p>
        <FitButtons
          details={props.buttonText}
          color='blue'
          icon={true}
          onClick={() => handleShowForm(props.to)}
        />
      </div>
    </div>
  );
};
